<template>
  <ul class="help-list">
    <li>
      <h2>{{ tituloLista }}</h2>
      <p><slot></slot></p>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    tituloLista: String
  }
};
</script>
<style scoped>
li p {
  font-size: 15px;
  line-height: 26px;
}
p {
  font-family: BentonSansBBVA-Book, Helvetica, Arial, sans-serif;
}
li {
  padding-left: 18px;
}
h2 {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  margin-bottom: 0px;
  display: inline-block;
  font-size: 15px;
  line-height: 26px;
}
li >>> p {
  margin-top: 0px;
}

.help-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
</style>
